// src/components/AgeretProductDetail.jsx

import React, { useState } from "react";
import "../assets/css/AgeretProductDetail.css";
import mainImage from "../assets/images/New-Products/rootIn.jpg";
import thumb1 from "../assets/images/New-Products/rootIn.jpg";
import thumb2 from "../assets/images/New-Products/rootIn.jpg";
import thumb3 from "../assets/images/All-Products/rootINF.png";
import howToUseVideo from "../assets/Video/meical video.mp4";
import BredcrumpImage from "../assets/images/hair-breadcrum.jpg";
import howToUseThumb from "../assets/images/hair-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";



const AgeretProductDetails = () => {
  const [selectedImage, setSelectedImage] = useState(mainImage);
  const [activeTab, setActiveTab] = useState("benefits");
  const [showVideo, setShowVideo] = useState(false);

  return (
    <>

      <BreadcrumbSection
        title="Transforming Hair Health Through Scientific Innovation."
        // subtitle="Committed to Excellence:"
        breadcrumbItems={[
          { label: "Home", to: "/" }, { label: "Hair Care", to: "/HairCareProducts" },

        ]}
        backgroundImage={BredcrumpImage}
      />

      <section className="product-details-section">

        <div className="container product-container">
          {/* Product Image and Details */}
          <div className="product-info">
            <div className="product-image-section">
              <img src={selectedImage} alt="Ageret Product" className="main-image" />
              <div className="thumbnail-row">
                {[thumb2].map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`Thumbnail ${i + 1}`}
                    className={`thumbnail ${selectedImage === img ? "active-thumb" : ""}`}
                    onClick={() => setSelectedImage(img)}
                  />
                ))}
              </div>
            </div>

            <div className="product-description">
              <h2>Root IN </h2>
              <p className="sub-heading text-muted">TREATMENT WITH MINOXIDIL AND PEPTIDES</p>
              <h5>Product Overview</h5>
              <p>
                Root In 5% Solution belongs to a class of drugs known as vasodilators.
                It is used to promote hair growth after hereditary hair loss (male pattern baldness).
                It is not used for sudden, patchy or unexplained hair loss.
                Root In 5% Solution should only be applied directly to the scalp area in the amount, and in the way, specified on the label or by your doctor.
                Clean and dry your scalp before using it. It may take several months before you notice any hair growth and the first growth may be soft, colourless and barely visible.
                Using more than recommended will not speed up hair growth and may cause dangerous side effects. This medication must be used continuously to maintain hair growth.
                If your condition does not improve or worsens after using it for 4 to 6 months, tell your doctor.
              </p>
            </div>
          </div>

          {/* How To Use Section */}
          {/* <div className="how-to-use-section" data-aos="fade-up">
            <div
              className="how-to-use-content"
              style={{
                backgroundImage: `url(${howToUseThumb})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="text-content">
                <h3>
                  How To Use <span className="highlight">Root IN?</span>
                </h3>
                <p>
                  Use this medicine in the dose and duration as advised by your doctor. Check the label for directions before use.
                </p>
              </div>
              <div className="video-thumbnail-wrapper" onClick={() => setShowVideo(true)}>
                <div className="video-thumbnail">
                  <i className="bi bi-play-fill play-icon"></i>
                </div>
              </div>
            </div>
          </div> */}

          {/* Video Popup Modal */}
          {showVideo && (
            <div className="video-popup">
              <div className="video-container">
                <video controls autoPlay>
                  <source src={howToUseVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                {/* Uncomment this block to use YouTube later */}
                {/*
              <iframe
                src="https://www.youtube.com/embed/VIDEO_ID?autoplay=1"
                title="How to Use Ageret"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
              */}

                <button className="close-btn" onClick={() => setShowVideo(false)}>
                  &times;
                </button>
              </div>
            </div>
          )}

          {/* Accordion Section */}
          <div className="accordion-section">
            <div className="accordion-tabs">
              {["benefits", "application", "ingredients"].map((tab) => (
                <button
                  key={tab}
                  className={`accordion-tab ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === "benefits"
                    ? "BENEFITS"
                    : tab === "application"
                      ? "APPLICATION GUIDELINES"
                      : tab === "ingredients"
                        ? "INGREDIENTS"
                        : "BEFORE–AFTER"}
                </button>
              ))}
            </div>

            <div className="accordion-content">
              {activeTab === "benefits" && (
                <div className="tab-content fade-in">
                  <p><strong>1. Benefits</strong></p>
                  <ul>
                    <ol>
                      <li>Root In 5% Solution is a serum used to treat chronic hair loss and AGA.</li>
                      <li>Acts as a potassium channel opener, increasing blood flow to hair follicles → better oxygen & nutrient delivery.</li>
                      <li>It can prevent further hair loss and help hair to re-grow.</li>
                      <li>It works by increasing blood flow to the hair follicles on your scalp, which prevents hair cell death and also enhances new hair growth.</li>
                      <li>Stimulates inactive follicles and helps restart the hair growth cycle.</li>
                      <li>Reduces follicle shrinkage and supports stronger hair strands.</li>
                      <li>You may notice initial shedding in the first few weeks—this is a normal part of the process as new, stronger hair begins to grow.</li>
                    </ol>
                  </ul>

                </div>
              )}
              {activeTab === "application" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li>Towel dry your hair.</li>
                      <li>Part your hair and spray 1 ml (4–5 sprays) on affected areas of the scalp.</li>
                      <li>Maximum dose – 2 ml per day.</li>
                    </ul>


                  </p>
                </div>
              )}
              {activeTab === "ingredients" && (
                <div className="tab-content fade-in">
                  <p>


                    <ul>
                      <li>
                        <strong>Minoxidil (5% w/v):</strong> Minoxidil plays a role in treating androgenetic alopecia (AGA).
                        It is a vasodilator that promotes hair growth by improving blood flow to the hair follicles, helping individuals with AGA regardless of sex.
                        Topical minoxidil is the only drug approved by the US FDA for this condition.
                      </li>

                      <li>
                        <strong>Procapil:</strong>
                        <ul>
                          <li>
                            <strong>Biotinoyl Tripeptide-1:</strong> A cosmetic ingredient used in hair care formulations.
                            It promotes hair growth by inhibiting 5-alpha reductase types 1 and 2, which convert testosterone to dihydrotestosterone (DHT)—a major factor in hair loss.
                            It also enhances the proliferation of hair bulb keratinocytes, supporting hair conditioning and improving hair density and scalp health.
                          </li>
                          <li>
                            <strong>Apigenin:</strong> A flavonoid abundant in chamomile flowers (about 68% of the total flavonoid content).
                            It stimulates microcirculation, improving blood flow to the scalp, and downregulates the TGF-beta 1 gene, which suppresses hair growth.
                            Apigenin also provides antioxidant and anti-inflammatory benefits, protecting the scalp from oxidative stress and inflammation.
                          </li>
                          <li>
                            <strong>Oleanolic Acid:</strong> A naturally occurring pentacyclic triterpenoid known for promoting hair matrix cell proliferation and improving cellular metabolism.
                            It supports healthier, more robust hair growth and also has hepatoprotective properties, helping protect the liver from damage.
                          </li>
                        </ul>
                      </li>


                    </ul>
                    <ol>
                      <li>Redensyl® – a stem cell activator, clinically proven to increase the anagen/telogen ratio by +9% and reduce telogen hairs by –17% in just 84 days.</li>
                      <li>AnaGain™ (pea sprout extract) – which upregulates FGF7 and Noggin, stimulating new follicle growth; studies show improved anagen/telogen ratio in 3 months.</li>
                      <li>Baicapil™ – a botanical complex that restores growth, increases density, and reduces shedding.</li>
                    </ol>
                  </p>
                </div>
              )}

            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default AgeretProductDetails;
